import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import CalendarEvent from './CalendarEvent';

const styles = () => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    width: `${1300 / 7}px`,
  },
});

const DayColumn = ({
  className,
  classes,
  day,
  hourStart,
  hourEnd,
  onAvailableClick,
  availabilityGaps,
}) => {
  const windowStart = moment(day)
    .startOf('day')
    .add(hourStart, 'h');

  const windowEnd = moment(day)
    .startOf('day')
    .add(hourEnd, 'h');

  const onAvailableEventClick = gap => () => {
    onAvailableClick(gap);
  };

  return (
    <div className={classNames(className, classes.root)}>
      {availabilityGaps.map(gap => (
        <CalendarEvent
          isUnavailable={gap.attr('isAvailable') !== 'true'}
          isOverrideable={gap.attr('overrideable') === 'true'}
          startTime={gap.attr('start')}
          endTime={gap.attr('end')}
          windowStart={windowStart}
          windowEnd={windowEnd}
          onClick={onAvailableEventClick(gap)}
        />
      ))}
    </div>
  );
};

DayColumn.defaultProps = {
  className: '',
};

DayColumn.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  day: PropTypes.object.isRequired,
  hourStart: PropTypes.number.isRequired,
  hourEnd: PropTypes.number.isRequired,
  onAvailableClick: PropTypes.func.isRequired,
  availabilityGaps: PropTypes.array.isRequired,
};

export default withStyles(styles)(DayColumn);
